<template>
    <v-dialog class="dialog" v-model="dialogAreaSize" persistent max-width="400">
        <v-card>
            <v-app-bar color="primary" dense dark>

                <v-toolbar-title>{{$t('edit_areas.area_size')}}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon text @click="$emit('closeDialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
 
            </v-app-bar>
            <v-card-title>
                <v-radio-group v-model="areaSize" mandatory>
                    <v-radio :label="$t('edit_areas.small')" value="small"></v-radio>
                    <v-radio :label="$t('edit_areas.medium')" value="medium"></v-radio>
                    <v-radio :label="$t('edit_areas.big')" value="big"></v-radio>
                </v-radio-group>
            </v-card-title>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="chooseAreaSize">
                    {{$t('save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DialogAreaSize',

    data() {
        return {
            areaSize: 'small'
        }
    },

    props: ['dialogAreaSize'],

    methods: {
        chooseAreaSize() {


            if (this.areaSize === 'small') this.$emit('changeMultiplier', 0.025) 

            if (this.areaSize === 'medium') this.$emit('changeMultiplier', 0.10) 

            if (this.areaSize === 'big') this.$emit('changeMultiplier', 0.15) 

            this.$emit('closeDialog')

            this.showToast(this.$t('edit_areas.instructions_create_msg'), this.$t('edit_areas.instructions_create_title'), 'info', {
                position: 'topCenter',
                color: "#90CAF9",
                class: 'alert',
                icon: 'icon mdi mdi-map-marker-plus-outline',

            })

        },
    },

}
</script>

<style>

</style>